import User01Icon from '@untitled-ui/icons-react/build/esm/User01';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import SvgIcon from '@mui/material/SvgIcon';
import { useSelector } from "react-redux";
import { AccountPopover } from './account-popover';
import { usePopover } from 'src/hooks/use-popover';

import UserAvatar from 'src/components/avatar/UserAvatar';
//import { useMockedUser } from 'src/hooks/use-mocked-user';

export const AccountButton = () => {
  //const user = useMockedUser();
  const popover = usePopover();
  const { user } = useSelector(state => state.User);

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: 'divider',
          height: 40,
          width: 40,
          borderRadius: '50%',
        }}
      >
        <UserAvatar
          sx={{
            height: 32,
            width: 32,
          }}
          user={user}
        >
          <SvgIcon>
            <User01Icon />
          </SvgIcon>
        </UserAvatar>
      </Box>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
